import { render } from "./Accountancy.vue?vue&type=template&id=03ae7c0b"
import script from "./Accountancy.vue?vue&type=script&lang=js"
export * from "./Accountancy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__